import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spin, Button, Typography, Alert, message } from "antd";
import {
  ArrowLeftOutlined,
  QrcodeOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import {
  Container,
  PaymentWrapper,
  DetailsSection,
  PIXSection,
  DetailItem,
} from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import Status from "../../../components/status";
import { ViewQRCode } from "../OS/styles";
import QRCode from "react-qr-code";
import { addDays, format } from "date-fns";
import { MdCopyAll } from "react-icons/md";

const { Title, Text, Paragraph } = Typography;

const PagamentoDetalhes = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [payment, setPayment] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadPayment();
  }, []);

  async function loadPayment() {
    setIsLoading(true);
    await api
      .get(`/payment/${id}`)
      .then((response) => {
        setPayment(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  return (
    <Container>
      <Button onClick={() => navigate(-1)} style={{ marginBottom: 20 }}>
        <ArrowLeftOutlined /> Voltar
      </Button>
      {isLoading ? (
        <Spin size="large" style={{ display: "block", marginTop: 50 }} />
      ) : payment ? (
        <PaymentWrapper>
          <DetailsSection>
            <Title level={3}>Detalhes da Transação</Title>
            <DetailItem>
              <Text>Status</Text>
              <Status isPayment={true} status={payment.status} />
            </DetailItem>
            <DetailItem>
              <Text>Tipo</Text>
              <Text strong>
                {payment.type == "OS"
                  ? "Ordem de Serviço"
                  : payment.type == "LEAD"
                  ? "Compra de Lead"
                  : " Deposito"}
              </Text>
            </DetailItem>
            <DetailItem>
              <Text>Valor</Text>
              <Title level={4} style={{ margin: 0, color: "#001b22" }}>
                {payment.value.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Title>
            </DetailItem>
            <DetailItem>
              <Text>Método</Text>
              <Text strong>{payment.method}</Text>
            </DetailItem>
            <DetailItem>
              <Text>Data</Text>
              <Text strong>
                {new Date(payment.update_at).toLocaleString("pt-br")}
              </Text>
            </DetailItem>
            <DetailItem>
              <Text>ID da Transação</Text>
              <Text code>{payment.id}</Text>
            </DetailItem>
          </DetailsSection>

          {payment.method === "PIX" && payment.status === "pendente" && (
            <ViewQRCode>
              <QRCode value={payment.pix.payload} />
              <p>
                QR Code válido até{" "}
                {format(
                  addDays(new Date(payment.create_at), 2),
                  "dd/MM/yyyy HH:mm"
                )}
              </p>
              <Button
                type="primary"
                onClick={() => {
                  navigator.clipboard
                    .writeText(payment.pix.payload)
                    .then(() =>
                      toast.success("PIX Copia e Cola copiado com sucesso")
                    )
                    .catch((err) => toast.error("Erro ao copiar texto: ", err));
                }}
              >
                Pix Copia e Cola
                <MdCopyAll />
              </Button>
            </ViewQRCode>
          )}
        </PaymentWrapper>
      ) : (
        <Title level={2} style={{ textAlign: "center", marginTop: 50 }}>
          Pagamento não encontrado
        </Title>
      )}
    </Container>
  );
};

export default PagamentoDetalhes;
